import { mapGetters } from 'vuex';
import {
  REPORT_LOAN_LIST_REQUEST,
  REPORT_LOAN_LIST_EXPORT,
  REPORT_END_DAY_REQUEST,
  REPORT_END_DAY_EXPORT,
} from '@/store/actions/report';
import { OFFICER_LIST_REQUEST } from '@/store/actions/officer';
import moment from 'moment';
import ReportTableWithHeader from '@/components/report/ReportTableWithHeader';

export default {
  components: {
    ReportTableWithHeader,
  },

  data() {
    return {
      rows: [],
      totalRecords: 0,
      page: 1,
      perPage: 20,
      pageSize: [10, 20, 30, 50, 100],
      totalPage: 1,
      form: {
        startDate: moment().format('YYYY-MM-DD'),
        endDate: moment().format('YYYY-MM-DD'),
        officerId: null,
        bankAccount: null,
      },
    };
  },

  computed: {
    ...mapGetters([
      'reportLoanList',
      'reportLoanListStatus',
      'reportLoanListMeta',
      'reportLoanExportStatus',
      'reportLoanExportLink',
    ]),
    isLoading() {
      return this.reportLoanListStatus === 'loading';
    },
    isDownloading() {
      return this.reportLoanExportStatus === 'loading';
    },
  },

  created() {
    this.fetchData();
    this.$store.dispatch(OFFICER_LIST_REQUEST);
  },

  methods: {
    onPerPageChange(perPage) {
      this.perPage = perPage;
      this.onPageChange(1);
    },

    onPageChange(page) {
      this.page = page;
      this.fetchData();
    },

    onFilter() {
      this.fetchData();
    },

    async onDownload() {
      const data = {
        filters: {},
      };

      data.filters[`filter[startDate]`] = this.form.startDate;
      data.filters[`filter[endDate]`] = this.form.endDate;
      data.filters[`filter[officerId]`] = this.form.officerId;
      data.filters[`filter[bankAccount]`] = this.form.bankAccount;

      await this.updateFilters(data);

      const payload = {
        // businessId: this.business.id,
        data,
      };

      if (this.reportType === 'endOfDay') {
        await this.$store.dispatch(REPORT_END_DAY_EXPORT, payload);
      } else {
        await this.$store.dispatch(REPORT_LOAN_LIST_EXPORT, payload);
      }
      if (this.reportLoanExportStatus === 'success') {
        window.open(`${this.reportLoanExportLink}`, '_blank');
      }
    },

    async fetchData() {
      const data = {
        filters: {},
        page: this.page,
        perPage: this.perPage,
      };

      data.filters[`filter[startDate]`] = this.form.startDate;
      data.filters[`filter[endDate]`] = this.form.endDate;
      data.filters[`filter[officerId]`] = this.form.officerId;
      data.filters[`filter[bankAccount]`] = this.form.bankAccount;

      await this.updateFilters(data);

      const payload = {
        // businessId: this.business.id,
        data,
      };

      if (this.reportType === 'endOfDay') {
        await this.$store.dispatch(REPORT_END_DAY_REQUEST, payload);
      } else {
        await this.$store.dispatch(REPORT_LOAN_LIST_REQUEST, payload);
      }
      this.rows = this.reportLoanList;
      this.totalRecords = this.reportLoanListMeta ? this.reportLoanListMeta.total : 1;
      this.page = this.reportLoanListMeta.currentPage;
      this.totalPage = this.reportLoanListMeta.lastPage;
    },

    updateFilter() {},
  },
};
